import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@wbk/ui';
import useLocalization from '@/context/localization/useLocalization';

const Error404 = () => {
  const { t } = useTranslation('common');
  const { locale } = useLocalization();

  return (
    <section className='relative flex min-h-[80vh] w-full items-center justify-center py-20'>
      <div className='container space-y-10 py-20'>
        <h1 className='font-gellix inline h-full text-[160px]'>404</h1>
        <div className='space-y-2'>
          <h2 className='text-4xl uppercase'>{t('common:errors.404')}</h2>
          <p className='text-lg'>{t('common:errors.404_description')}</p>
        </div>
        <Button
          as={Link}
          to={`/${locale}`}
          theme='white'
          shape='outlined'
          className='w-full max-w-xs'
        >
          {t('common:go_home')}
        </Button>
      </div>
    </section>
  );
};

export default Error404;
